import React from 'react';
import { Card, Typography, Empty } from 'antd';
import { DatabaseOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Inventory = () => (
  <div>
    <Title level={3}>Inventario</Title>
    <Card bordered={false} style={{ borderRadius: 8, textAlign: 'center', padding: 40 }}>
      <Empty
        image={<DatabaseOutlined style={{ fontSize: 64, color: '#197278' }} />}
        description={
          <div>
            <Title level={4} style={{ marginTop: 16 }}>Control de Inventario</Title>
            <Paragraph type="secondary">
              CEDIS (37 ubicaciones), Hidalgo y Victoria. 3,902 reglas de mín/máx con
              sistema de temporadas automático.
            </Paragraph>
            <Paragraph type="secondary">Disponible en Fase 5</Paragraph>
          </div>
        }
      />
    </Card>
  </div>
);

export default Inventory;
